import {userConstants} from '../constants/ActionTypes';

let userData = null;
if (localStorage.getItem('user')) {
  try {
    userData = JSON.parse(localStorage.getItem('user'));
  } catch (ex) { console.error(ex); }
}

const initialState = {
  token: localStorage.getItem('token'),
  data: userData,
  isLoggingIn: false,
  isLoggedIn: !!userData
};

const users = (state = initialState, action) => {
  switch (action.type) {

    case userConstants.LOGIN_REQUEST:
      return { ...state, isLoggingIn: true };

    case userConstants.LOGOUT:
      state.data = null;
      state.isLoggedIn = false;
      return state;

    case userConstants.LOGIN_SUCCESS:
      state.data = action.data.user;
      state.token = action.data.token;
      state.isLoggedIn = true;
      state.isLoggingIn = false;
      return state;

    case userConstants.LOGIN_FAILURE:
      state.data = null;
      state.token = null;
      state.isLoggingIn = false;
      state.isLoggedIn = false;
      return state;

    default:
      return state;
  }
};

module.exports = users;



// WEBPACK FOOTER //
// ./reducers/users.reducers.js